module.exports = __webpack_public_path__ + "static/media/saveImg2.a297d428.svg";